/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeSummaryResource
 */
export interface EmployeeSummaryResource {
    /**
     * 
     * @type {string}
     * @memberof EmployeeSummaryResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeSummaryResource
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeSummaryResource
     */
    lastname: string;
}

/**
 * Check if a given object implements the EmployeeSummaryResource interface.
 */
export function instanceOfEmployeeSummaryResource(value: object): value is EmployeeSummaryResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('firstname' in value) || value['firstname'] === undefined) return false;
    if (!('lastname' in value) || value['lastname'] === undefined) return false;
    return true;
}

export function EmployeeSummaryResourceFromJSON(json: any): EmployeeSummaryResource {
    return EmployeeSummaryResourceFromJSONTyped(json, false);
}

export function EmployeeSummaryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeSummaryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
    };
}

export function EmployeeSummaryResourceToJSON(value?: EmployeeSummaryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
    };
}

